import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const ProjectCardSkeleton = () => (
  <Card className="overflow-hidden">
    {/* Image placeholder - matches aspect-square on mobile, aspect-video on desktop */}
    <Skeleton className="aspect-square md:aspect-video w-full" />
    <CardContent className="p-2.5 md:p-4">
      {/* Title */}
      <Skeleton className="h-4 md:h-5 w-3/4 mb-1 md:mb-2" />
      {/* Style/room info - hidden on mobile */}
      <div className="hidden md:flex items-center justify-between mb-2">
        <Skeleton className="h-4 w-1/3" />
        <Skeleton className="h-4 w-1/4" />
      </div>
      {/* Date on mobile */}
      <Skeleton className="h-3 w-1/2 mb-1.5 md:hidden" />
      {/* Expiry indicator */}
      <Skeleton className="h-3 w-1/3 mb-2 md:mb-3" />
      {/* Action buttons */}
      <div className="flex gap-1.5 md:gap-2">
        <Skeleton className="h-7 md:h-9 flex-1" />
        <Skeleton className="h-7 md:h-9 w-16 md:w-20" />
        <Skeleton className="h-7 md:h-9 w-8 md:w-10" />
      </div>
    </CardContent>
  </Card>
);
